<template>
  <div class="p-grid">
    <div class="p-col-12">
      <div class="specific-filters">
        <div class="p-grid p-nogutter">
          <div class="p-col-6 position-switch">
            <div v-show="displayMyOperationsAgentFilter">
              <span class="text_switch">{{
                $t("operacion.misOperaciones")
              }}</span>
              <span
                ><InputSwitch
                  v-model="checkedMyOperations"
                  inputId="misOperaciones"
                  ariaLabelledBy="misOperacionesLabel"
              /></span>
            </div>
            <div v-show="displayMyClaimsAgentFilter">
              <span class="text_switch">{{
                $t("reclamacion.misReclamaciones")
              }}</span>
              <span
                ><InputSwitch
                  v-model="checkedMyClaims"
                  inputId="misReclamaciones"
                  ariaLabelledBy="misReclamacionesLabel"
              /></span>
            </div>
          </div>
          <div class="p-col-6">
            <Dropdown
              v-model="selectedDate"
              :options="dates"
              optionLabel="name"
              optionValue="code"
              class="p-column-filter estado-dropdown"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DatesMixin from "@/utils/dates";
export const UNTIL_NOW = "until_now";
export const LAST_DAY = "last_day";
export const LAST_WEEK = "last_week";
export const LAST_MONTH = "last_month";
export const LAST_YEAR = "last_year";

export default {
  mixins: [DatesMixin],
  name: "SpecificFilters",
  data() {
    return {
      checkedMyOperations: false,
      checkedMyClaims: false,
      selectedDate: UNTIL_NOW,
      dates: [
        {
          name: this.$i18n.t("specificFilters.dateFilter.hastaAhora"),
          code: UNTIL_NOW,
        },
        {
          name: this.$i18n.t("specificFilters.dateFilter.ultimoDia"),
          code: LAST_DAY,
        },
        {
          name: this.$i18n.t("specificFilters.dateFilter.ultimaSemana"),
          code: LAST_WEEK,
        },
        {
          name: this.$i18n.t("specificFilters.dateFilter.ultimoMes"),
          code: LAST_MONTH,
        },
        {
          name: this.$i18n.t("specificFilters.dateFilter.ultimoAnho"),
          code: LAST_YEAR,
        },
      ],
      filtersDates: [],
    };
  },
  props: [
    "dateFieldName",
    "checkedSwitch",
    "displayMyOperationsAgentFilter",
    "displayMyClaimsAgentFilter",
  ],
  methods: {},
  watch: {
    checkedMyOperations() {
      this.$emit("searchBySpecificFilters", {
        type: "check",
        value: this.checkedMyOperations,
      });
    },
    checkedMyClaims() {
      this.$emit("searchBySpecificFilters", {
        type: "check",
        value: this.checkedMyClaims,
      });
    },
    filtersDates() {
      this.$emit("searchBySpecificFilters", {
        type: "date",
        value: this.filtersDates,
      });
    },
    selectedDate() {
      var start = null;
      var end = null;
      let filters = [];
      var today = new Date();
      switch (this.selectedDate) {
        case LAST_DAY:
          start = new Date();
          end = new Date(start.getTime());
          filters = this.buildFilterBetween(this.dateFieldName, start, end);
          this.filtersDates = filters;
          break;
        case LAST_WEEK:
          start = this.getMondayOfCurrentWeek(today);
          end = this.getSundayOfCurrentWeek(today);
          filters = this.buildFilterBetween(this.dateFieldName, start, end);
          this.filtersDates = filters;
          break;
        case LAST_MONTH:
          start = this.getFirstDayOfCurrentMonth(today);
          end = this.getLastDayOfCurrentMonth(today);
          filters = this.buildFilterBetween(this.dateFieldName, start, end);
          this.filtersDates = filters;
          break;
        case LAST_YEAR:
          start = this.getFirstDayOfCurrentYear(today);
          end = this.getLastDayOfCurrentYear(today);
          filters = this.buildFilterBetween(this.dateFieldName, start, end);
          this.filtersDates = filters;
          break;
        default:
          filters = this.buildFilterLessToday(this.dateFieldName);
          this.filtersDates = filters;
          break;
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.specific-filters {
  background: #f8f9fa;
  color: #495057;
  border: 1px solid #e9ecef;
  border-width: 1px 0 1px 0;
  padding: 1rem 1rem;
  font-weight: 600;
}
.position-switch span {
  vertical-align: middle;
}
.text_switch {
  margin-right: 2px;
}
</style>
